import { GridColDef, GridColumns, GridRowParams } from '@mui/x-data-grid-premium';
import { filterOperators } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import ConfirmationDeleteTableDialog from 'components/helpers/ConfirmationGridDelete';

export function MedicalServicesEtlFieldColumns(handleDelete?: any): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'field_from',
      headerName: t(`global.field_from`),
      filterOperators,
      width: 200,
      editable: true,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'field_to',
      headerName: t(`global.field_to`),
      filterOperators,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'field_to_description',
      headerName: t(`global.field_to_description`),
      filterOperators,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'transcode',
      headerName: t(`global.transcode`),
      filterOperators,
      editable: true,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'order',
      headerName: t(`global.order`),
      editable: true,
      width: 200,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        const actions = [
          <ConfirmationDeleteTableDialog key={997} id={params.row.id} handleDelete={handleDelete} />
        ];
        return actions;
      },
      filterable: false
    }
  ];
  return columns;
}
